export const translations = {
  it: {
    nav: {
      home: "HOME",
      chiSono: "CHI SONO",
      comeFunziona: "LO SPORT",
      percorso: "PERCORSO",
      risultati: "RISULTATI",
      news: "NEWS",
      gallery: "GALLERY",
      sponsor: "SPONSOR",
      collaborazioni: "COLLABORAZIONI",
      contatti: "CONTATTI",
    },
    common: {
      showAllCount: "Vedi tutto (+{n})",
    },
    comeFunziona: {
      eyebrow: "Capire lo sport",
      titleA: "COME FUNZIONA LO SCI ALPINO ",
      titleAccent: "PARALIMPICO",
      subtitle: "Tre modi di scendere in pista, una sola velocità. In gara ogni categoria ha il suo podio e la sua premiazione: ipovedenti con ipovedenti, in piedi con in piedi, seduti con seduti. Tocca la mia categoria per scoprire classi e fattore di compensazione.",
      cta: "Scopri le classi AS1–AS3",
      cats: {
        vi: {
          title: "Ipovedenti",
          tag: "La mia categoria",
          text: "Si gareggia in coppia: una guida scia davanti e detta la traiettoria con la voce. Due corpi, una sola linea.",
        },
        standing: {
          title: "In Piedi",
          tag: "Standing",
          text: "Atleti con disabilità agli arti che sciano in piedi, con protesi o stabilizzatori. Stessa pista, stessa velocità.",
        },
        sitting: {
          title: "Seduti",
          tag: "Sitting",
          text: "Si scia seduti su un mono-sci: una seduta con ammortizzatore montata su un solo sci.",
        },
      },
    },
    vi: {
      eyebrow: "Come funziona",
      titleA: "CATEGORIA ",
      titleAccent: "IPOVEDENTI",
      intro: "Nella mia categoria si scia in coppia: la guida davanti indica la linea con la voce, io la seguo a oltre cento all'ora. Gli atleti sono divisi in classi in base a quanto vedono — e il cronometro si adatta a ciascuna.",
      myClass: "La mia classe",
      factorLabel: "Fattore",
      disciplineLabel: "Disciplina",
      classes: {
        as1: {
          name: "Ciechi totali",
          short: "ciechi totali",
          what: "Non vedono nulla: in gara seguono solo la voce della guida, che arriva da un autoparlante.",
          simple: "In pista contano solo la voce, la memoria del tracciato e la fiducia.",
        },
        as2: {
          name: "Ipovedenti gravi",
          short: "ipovedenti gravi",
          what: "Atleti ipovedenti con vista molto ridotta.",
          simple: "Con la guida ci si parla tramite microfono nel casco, curva dopo curva.",
        },
        as3: {
          name: "Ipovedenti",
          short: "ipovedenti",
          what: "Atleti ipovedenti: il visus non supera mai 1/10 per occhio. È la mia classe.",
          simple: "Con la guida ci si parla tramite microfono nel casco: la traiettoria la leggiamo insieme.",
        },
      },
      raceTitleA: "IL FATTORE DI ",
      raceTitleAccent: "COMPENSAZIONE",
      raceText: "In pista un AS3 scia più forte di un AS1 e taglia il traguardo per primo. Ma il tempo che conta è il tempo reale moltiplicato per il fattore della classe: più la disabilità è grave, più il fattore è basso — il cronometro scorre più lentamente. Guarda come i tempi finali si allineano.",
      raceStart: "Avvia la gara",
      raceRunning: "Gara in corso...",
      raceCorrecting: "Applicazione fattore...",
      raceReplay: "Rigioca",
      raceArrived: "Arrivo!",
      raceTargetLabel: "Tempo craccato",
      netTime: "Tempo reale",
      corrTime: "Tempo corretto",
      raceConclusion: "Sulla neve ha vinto l'AS3, il più veloce in assoluto. Ma dopo la moltiplicazione per i fattori i tre tempi coincidono: gara pari. È così che classi con disabilità diverse possono correre la stessa gara.",
      raceDisclaimer: "Fattori ufficiali FIS per la categoria VI nella disciplina selezionata; i tempi di gara sono un esempio didattico.",
      calcTitle: "CONVERTITORE DI TEMPI",
      calcText: "Da tempo reale a tempo craccato e viceversa: inserisci i tempi di più atleti dopo una gara e confrontali.",
      calcDirToFactored: "Reale → Craccato",
      calcDirToReal: "Craccato → Reale",
      calcInputReal: "Tempo reale (in pista)",
      calcInputFactored: "Tempo craccato (ufficiale)",
      calcOutputFactored: "Tempo craccato",
      calcOutputReal: "Tempo reale",
      calcPlaceholder: "es. 62.34 oppure 1:02.34",
      calcInvalid: "Formato non valido",
      calcAthlete: "Atleta {n}",
      calcRanking: "Classifica comparata",
      guidesTitle: "LE MIE GUIDE",
      guidesText: "Dietro ogni mia gara c'è una guida che scia davanti e mi parla in cuffia a ogni curva. Dal più recente al primo:",
      guideCurrent: "Attuale",
    },
    hero: {
      badge: "Sci Alpino Paralimpico — Visually Impaired",
      payoff: "Oltre il buio, la velocità pura. La montagna non si guarda: si sente, si vive, si vince.",
      ctaPercorso: "Scopri il mio percorso",
      ctaRisultati: "Vedi il medagliere",
      ctaCollab: "Collaboriamo",
      scrollAria: "Scorri giù",
      imgAlt: "Giacomo Bertagnolli in gara",
    },
    marquee: {
      identity: [
        "SCI ALPINO PARALIMPICO",
        "GUIDA: ANDREA RAVELLI",
        "OLTRE IL BUIO, LA VELOCITÀ PURA",
      ],
      results: [
        "124 MEDAGLIE IN COPPA DEL MONDO",
        "2 COPPE DEL MONDO GENERALI",
        "CAMPIONE MONDIALE E PARALIMPICO",
      ],
      honors: [
        "PORTABANDIERA A PECHINO 2022",
        "COMMENDATORE DELLA REPUBBLICA",
      ],
    },
    chiSono: {
      outline: "CHI SONO",
      eyebrow: "Chi sono",
      titleA: "LA MONTAGNA NON SI GUARDA.",
      titleB1: "SI ",
      titleAccent: "SENTE",
      titleB2: ".",
      badge: "IPOVEDENTE · CAT. AS3",
      photoFlagCaption: "Portabandiera — Beijing 2022",
      photoMattarellaCaption: "Il Tricolore dal Presidente Mattarella — Quirinale 2021",
      photoInspectCaption: "Ricognizione pre-gara — Discesa libera, Milano Cortina 2026",
      photoSlalomCaption: "Gara di slalom — Milano Cortina 2026",
      p1: "Sono nato a Cavalese, in Val di Fiemme, il 18 gennaio 1999. Sono ipovedente dalla nascita, a causa di un'atrofia bilaterale del nervo ottico. Ho imparato presto che, nello sci, la vista è solo uno dei modi per leggere una pista: servono anche istinto, memoria, sensibilità e fiducia.",
      body: [
        "La mia carriera agonistica inizia nella stagione 2012/13. Nel 2014/15 entro nella Nazionale italiana e nel 2015 debutto in Coppa del Mondo, conquistando il mio primo podio in gigante a St. Moritz.",
        "In gara scio seguendo la voce e i movimenti della mia guida. Oggi è Andrea Ravelli; prima di lui, al mio fianco, ci sono stati Achille Crispino e Fabrizio Casal. Due atleti, una sola traiettoria: un'intesa fatta di coordinazione, ascolto e fiducia reciproca, anche quando la velocità supera i cento all'ora.",
        "Dal 2017 indosso i colori delle Fiamme Gialle e dal 2022 faccio parte a tutti gli effetti della Guardia di Finanza.",
        "Nel 2022, a Madonna di Campiglio, sono diventato il primo atleta paralimpico ad aprire una gara di Coppa del Mondo dello sci alpino normodotato. Nello stesso anno, il Presidente della Repubblica Sergio Mattarella mi ha nominato Commendatore dell'Ordine al Merito della Repubblica Italiana.",
        "Ho avuto inoltre l'onore di essere portabandiera dell'Italia in due edizioni dei Giochi Paralimpici, un ruolo che mi ha permesso di rappresentare il mio Paese e i valori dello sport in un contesto che va oltre la competizione.",
        "Lo sport mi ha portato a raggiungere traguardi importanti, ma per me ogni risultato è un punto di partenza, non un punto di arrivo.",
        "Oggi il mio obiettivo è continuare a migliorare, come atleta, come sciatore e come persona. Cercare nuovi stimoli, alzare continuamente l'asticella e mettermi alla prova, dentro e fuori dalla pista.",
        "Allo stesso tempo, voglio condividere la mia passione, le mie esperienze e ciò che lo sport mi ha insegnato con chi mi segue, con chi ama la montagna e con le realtà che credono nel valore dello sport e delle persone. Perché le esperienze acquistano ancora più valore quando possono diventare uno stimolo anche per gli altri.",
        "La mia storia parla di sci, competizione e obiettivi da raggiungere. Ma anche di fiducia, determinazione e voglia di spingermi sempre oltre.",
      ],
      closing: "Il prossimo obiettivo? Continuare a vincere. In pista, e non solo.",
      stats: ["Medaglie in Coppa del Mondo", "Medaglie ai Mondiali", "Medaglie Paralimpiche", "Coppe di Specialità"],
      portraitAlt: "Ritratto di Giacomo Bertagnolli",
      actionAlt: "Giacomo in azione sulla neve",
      fedFisi: "Federazione Italiana Sport Invernali",
      fedFg: "Gruppi Sportivi Fiamme Gialle",
      fedAgitos: "Simbolo Paralimpico (Agitos)",
    },
    percorso: {
      eyebrow: "Il mio percorso",
      titleA: "OGNI CURVA HA ",
      titleAccent: "LA SUA STORIA",
      subtitle: "Tocca un anno per aprire i risultati di quella stagione nell'archivio completo.",
      ctaYear: "Risultati",
      items: [
        { title: "Milano Cortina 2026", desc: "I Giochi in casa: 5 medaglie su 5 gare e il record italiano di 13 podi paralimpici.", tag: "Paralimpiadi" },
        { title: "Maribor e la stagione perfetta", desc: "Due ori mondiali e l'en-plein in Coppa del Mondo: generale più tutte le coppe di specialità.", tag: "Mondiali & Coppa" },
        { title: "Mondiali di Espot", desc: "Altri due titoli iridati — gigante e slalom — più argento e bronzo.", tag: "Mondiali" },
        { title: "Beijing 2022", desc: "Portabandiera all'apertura, poi due ori e due argenti. A fine anno, Commendatore della Repubblica.", tag: "Paralimpiadi" },
        { title: "Il poker mondiale", desc: "Tra Sella Nevea e Kranjska Gora: quattro titoli mondiali su cinque.", tag: "Mondiali" },
        { title: "PyeongChang 2018", desc: "Debutto paralimpico da sogno a 19 anni: due ori, un argento, un bronzo.", tag: "Paralimpiadi" },
        { title: "Primo titolo iridato", desc: "Ai Mondiali di Tarvisio, in casa, il primo oro mondiale della carriera. Nello stesso anno divento il primo atleta paralimpico a entrare ufficialmente in un gruppo sportivo: le Fiamme Gialle.", tag: "Mondiali" },
        { title: "La prima Coppa del Mondo", desc: "Ad Aspen, in Colorado, con la guida Fabrizio Casal vinco la mia prima Coppa del Mondo generale.", tag: "Coppa del Mondo" },
        { title: "Nazionale e primo podio World Cup", desc: "Esordio in Coppa del Mondo con la nazionale: subito podio a St. Moritz.", tag: "Coppa del Mondo" },
        { title: "L'inizio di tutto", desc: "La prima gara e il primo podio italiano, a Campo Felice. Da lì, solo discesa.", tag: "Origini" },
      ],
    },
    a11y: {
      open: "Apri le opzioni di accessibilità",
      close: "Chiudi il pannello accessibilità",
      title: "ACCESSIBILITÀ",
      desc: "Strumenti pensati per chi naviga con lo screen reader o preferisce una lettura più facile.",
      mode: "Modalità accessibile",
      modeHint: "Testo più grande, contrasto alto, niente animazioni",
      listen: "Ascolta la pagina",
      listenSection: "Ascolta questa sezione",
      stop: "Ferma la lettura",
      skip: "Salta al contenuto",
    },
    podio: {
      eyebrow: "Risultati",
      titleA: "IL ",
      titleAccent: "MEDAGLIERE",
      subtitle: "Ogni medaglia è una storia di neve, fiducia e velocità. I conteggi si aggiornano in automatico a ogni nuovo risultato.",
      tabs: { paralimpiadi: "Paralimpiadi", mondiali: "Campionati Mondiali", coppa_mondo: "Coppa del Mondo", coppe: "Globi di cristallo", collare: "Collare d'Oro" },
      place1: "1° POSTO",
      place2: "2° POSTO",
      place3: "3° POSTO",
      ctaAll: "Vedi tutti i risultati",
      collareTitle: "COLLARE D'ORO AL MERITO SPORTIVO",
      collareSub: "La massima onorificenza sportiva italiana — 6 volte",
      diplomaNote: "+ Diploma d'Onore 2026",
      cupOverall: "COPPE DEL MONDO GENERALI",
      cupOverallSub: "Stagioni 2015–16 · 2019–20",
      cupDiscipline: "COPPE DEL MONDO DI SPECIALITÀ",
      cupDisciplineSub: "Discesa · Super-G · Gigante · Slalom",
      videoHint: "— e rivivi le gare: guarda i video",
    },
    news: {
      eyebrow: "Resta aggiornato",
      titleA: "AGENDA ",
      titleAccent: "E NOVITÀ",
      subtitle: "Le prossime gare in calendario e gli ultimi racconti da dentro e fuori la pista.",
      agendaHeading: "Prossime gare",
      pastHeading: "Le gare della stagione",
      newsHeading: "Ultime notizie",
      emptyAgenda: "Il calendario della nuova stagione sarà pubblicato a breve. Resta sintonizzato!",
      emptyNews: "Nessuna notizia per ora: torna presto a trovarmi.",
      showAll: "Vedi tutte le gare (+{n})",
      showLess: "Mostra meno",
      readMore: "Leggi tutto",
      zoomImage: "Apri l'immagine a schermo intero",
      close: "Chiudi",
      circuitWc: "Coppa del Mondo",
      circuitWch: "Mondiali",
      circuitPar: "Paralimpiadi",
      legendTech: "tecniche",
      legendSpeed: "veloci",
      noFilterResults: "Nessuna gara con i filtri selezionati: riattiva una categoria o un tipo di disciplina.",
      noEvents: "Nessun evento in programma per ora.",
      openMaps: "Apri su Google Maps",
      eventsHeading: "Prossimi eventi",
      inDays: "TRA {n} GIORNI",
      today: "OGGI",
      tomorrow: "DOMANI",
      read: "Leggi",
      disciplines: "Discipline",
      archiveCta: "Archivio stampa",
    },
    video: {
      eyebrow: "I video",
      title: "VIDEO DELLE GARE",
      subtitle: "Le manche complete e le premiazioni: i player partono esattamente al momento della gara.",
      run1: "1ª manche",
      run2: "2ª manche",
      premiazione: "Premiazione",
      partGara: "Gara",
      partSG: "Super-G · 1ª manche",
      partSL: "Slalom · 2ª manche",
      partPE: "Parallel Event",
      scopeVi: "categoria VI completa",
      scopeFull: "gara completa",
      commentIt: "Commento in italiano",
      commentEn: "Commento in inglese",
      openExt: "Guarda su",
      extraTitle: "INTERVISTE E SERVIZI TV",
      extraSub: "Servizi televisivi, interviste e riconoscimenti: si aprono sul sito della fonte.",
      seasonLabel: "Stagione",
      archiveTitle: "Dagli archivi TV",
      open: "Guarda i video",
      raiFolder: "VIDEO RAI ED ESTERNI",
      raiNote: "I video non incorporabili (Rai, Eurosport e altri) sono raccolti qui: si aprono sul sito della fonte.",
      disc: { gs: "Slalom Gigante", sl: "Slalom Speciale", dh1: "Discesa Libera 1", dh2: "Discesa Libera 2", dh3: "Discesa Libera 3", sg1: "Super-G 1", sg2: "Super-G 2", pe: "Parallel Event", evento: "Evento" },
    },
    press: {
      eyebrow: "Dicono di me",
      titleA: "ARCHIVIO ",
      titleAccent: "STAMPA",
      subtitle: "Gli articoli delle testate italiane e internazionali, raccolti per evento e sempre aggiornati.",
      statArticles: "articoli",
      statSources: "testate",
      all: "Tutti",
      readArticle: "Leggi l'articolo",
      backArchive: "Archivio stampa",
      readOriginal: "Leggi l'articolo originale",
      externalNote: "Questo articolo è pubblicato sul sito della testata: il bottone apre la fonte in una nuova scheda.",
      notFound: "Articolo non trovato.",
      empty: "Nessun articolo in archivio per ora.",
      groups: {
        "milano-cortina-2026": "Paralimpiadi Milano Cortina 2026",
        "sanremo-2026": "Festival di Sanremo 2026",
        "onorificenze": "Onorificenze e Istituzioni",
        "mondiali-2025": "Mondiali di Maribor 2025",
        "coppa-del-mondo": "Coppa del Mondo",
        "beijing-2022": "Paralimpiadi Beijing 2022",
        "pyeongchang-2018": "Paralimpiadi PyeongChang 2018",
        "altro": "Altri articoli",
      },
    },
    gallery: {
      eyebrow: "Momenti",
      titleA: "GLI ",
      titleAccent: "ALBUM",
      subtitle: "Apri un album per sfogliare le foto più belle.",
      photosCount: "{n} foto",
      loading: "Caricamento album...",
      emptyPhotos: "Le foto di questo album arriveranno presto.",
      close: "Chiudi",
      lightboxAlt: "Foto album",
      prev: "Foto precedente",
      next: "Foto successiva",
    },
    sponsor: {
      eyebrow: "Sponsor e partner",
      titleA: "INSIEME SI VA ",
      titleAccent: "PIÙ FORTE",
      subtitle: "Dietro ogni discesa c'è una squadra: chi mi equipaggia e chi crede nello sport paralimpico. Tocca un logo per scoprire la collaborazione.",
      mainTitle: "SPONSOR",
      techTitle: "SPONSOR TECNICI",
      tagMain: "Sponsor",
      tagTech: "Sponsor Tecnico",
      loading: "Caricamento sponsor...",
    },
    collab: {
      eyebrow: "Collaborazioni",
      titleA: "COLLABORAZIONI ",
      titleAccent: "ED EVENTI",
      subtitle: "Incontri, eventi e progetti nati con aziende che hanno voluto raccontare i loro valori attraverso la mia storia. Tocca un logo per scoprire il progetto.",
      tagline: "Progetto speciale",
      taglineYear: "Progetto speciale · {year}",
      ctaTitleA: "UN PROGETTO DA COSTRUIRE ",
      ctaTitleAccent: "INSIEME",
      ctaText: "Se pensi che la mia esperienza — in pista e fuori — possa essere interessante per la tua azienda, possiamo costruire qualcosa insieme. Un evento, un incontro, un racconto: partiamo da un caffè e da un'idea.",
      ctaBtn: "Parliamone",
      outline: "INSIEME",
    },
    oltre: {
      eyebrow: "Oltre lo sport",
      titleA: "LA MIA STORIA PUÒ USCIRE",
      titleAccent: "DALLA PISTA",
      lead: "La mia esperienza può diventare il punto di partenza per nuovi progetti.",
      body: "In pista ho imparato cose che non trovi sui libri: cosa significa fidarsi di qualcuno a cento all'ora, trasformare un limite in un metodo, ripartire dopo ogni caduta. Quando un'azienda mi chiama — per un incontro, un evento, un progetto — porto questo: non un discorso motivazionale, ma la mia storia, vera.",
      cta: "Scopri i progetti",
      ctaContact: "Scrivimi",
      altA: "Progetto con azienda",
      altB: "Dietro le quinte di un progetto",
    },
    contatti: {
      eyebrow: "Contatti",
      titleA: "SCENDIAMO IN PISTA",
      titleAccent: "INSIEME",
      subtitle: "Stampa, sponsor, eventi o semplicemente per fare due chiacchiere sullo sci paralimpico: scrivimi. Ogni collaborazione è una nuova partenza.",
      follow: "Seguimi sui social",
      namePh: "Nome e cognome",
      emailPh: "Email",
      orgPh: "Organizzazione / Azienda (opzionale)",
      subjectPh: "Oggetto",
      messagePh: "Il tuo messaggio",
      submit: "Invia messaggio",
      sending: "Invio in corso...",
      toastSuccess: "Messaggio inviato! Ti risponderò al più presto.",
    },
    modal: {
      project: "Il progetto",
      experience: "La mia esperienza",
      cta: "Parliamone",
      visit: "Visita l'azienda",
      close: "Chiudi",
    },
    footer: {
      admin: "Area Riservata",
      rights: "Tutti i diritti riservati",
    },
    risultati: {
      back: "Torna alla home",
      eyebrow: "Archivio completo",
      titleA: "TUTTI I ",
      titleAccent: "RISULTATI",
      subtitle: "Apri un'edizione o una stagione per esplorare le tappe e le singole gare.",
      statRaces: "gare disputate",
      statPodiums: "podi",
      statWins: "vittorie",
      filters: { tutti: "Tutti", paralimpiadi: "Paralimpiadi", mondiali: "Mondiali", coppa_mondo: "Coppa del Mondo", coppe: "Globi di cristallo", altro: "Altro", onorificenze: "Onorificenze" },
      searchPh: "Cerca gara, località...",
      mapTitle: "LE GARE NEL MONDO",
      mapHint: "Ogni pin è uno stato: toccalo per aprire le sue gare · trascina e zooma per esplorare",
      mapOpen: "Guarda su mappa",
      mapZoomIn: "Zoom avanti",
      mapZoomOut: "Zoom indietro",
      mapLegendGold: "Sedi di vittorie",
      mapLegendOther: "Altre gare",
      mapStats: "{races} gare · {podiums} podi · {venues} sedi",
      loading: "Caricamento risultati...",
      empty: "Nessun risultato trovato.",
      racesCount: "{n} gare",
      seasonEyebrow: "Stagione",
      eventEyebrow: { paralimpiadi: "Paralimpiadi", mondiali: "Campionati Mondiali" },
      altroHeading: "Gare FIS · Campionati Italiani · Coppa Europa",
      golds: "Ori",
      silvers: "Argenti",
      bronzes: "Bronzi",
      honoursTitle: "ONORIFICENZE",
      coppeTitle: "GLOBI DI CRISTALLO",
      coppeSub: "Le Coppe del Mondo: la classifica generale e i globi di specialità vinti, stagione per stagione.",
      coppeOverall: "Coppa del Mondo generale",
      coppeDownhill: "Discesa libera",
      coppeSuperG: "Super-G",
      coppeGiant: "Slalom gigante",
      coppeSlalom: "Slalom speciale",
      coppeSummaryOverall: "generali",
      coppeSummaryDisc: "di specialità",
      honoursSub: "Non sono medaglie, ma i riconoscimenti più alti dello sport italiano e dello Stato: per questo hanno uno spazio tutto loro.",
      collareChip: "Collare d'Oro",
      collareTagline: "La massima onorificenza sportiva italiana, assegnata dal CONI — vinta 6 volte",
      diplomaNew: "Nuovo",
      flagTagline: "Alfiere azzurro in due edizioni dei Giochi Paralimpici",
      flagPhotoAlt: "Giacomo Bertagnolli con la bandiera italiana a Beijing 2022",
      flagClosing: "Cerimonia di chiusura",
      flagOpening: "Cerimonia di apertura",
      diplomaTagline: "Il riconoscimento del CONI per chi il Collare d'Oro lo ha già conquistato",
      diplomaText: "Il 12 ottobre 2026, a Roma, il CONI mi ha consegnato il Diploma d'Onore al Merito Sportivo per le cinque medaglie vinte ai Giochi di Milano Cortina 2026: dopo sei Colliri d'Oro, chi continua a vincere riceve il Diploma.",
      commendatoreTagline: "Ordine al Merito della Repubblica Italiana",
      commendatoreText: "Il 2 giugno 2022 il Presidente Mattarella mi ha conferito l'onorificenza di Commendatore al Merito della Repubblica Italiana: è il riconoscimento con cui lo Stato premia chi dà lustro al Paese, nello sport e non solo.",
      photoComing: "Foto in arrivo",
    },
    lang: { label: "Lingua", it: "IT", en: "EN" },
  },
  en: {
    nav: {
      home: "HOME",
      chiSono: "ABOUT",
      comeFunziona: "THE SPORT",
      percorso: "JOURNEY",
      risultati: "RESULTS",
      news: "NEWS",
      gallery: "GALLERY",
      sponsor: "SPONSORS",
      collaborazioni: "COLLABORATIONS",
      contatti: "CONTACT",
    },
    common: {
      showAllCount: "Show all (+{n})",
    },
    comeFunziona: {
      eyebrow: "Understanding the sport",
      titleA: "HOW PARA ALPINE ",
      titleAccent: "SKIING WORKS",
      subtitle: "Three ways to race down the course, one single speed. In races each category has its own podium and award ceremony: visually impaired with visually impaired, standing with standing, sitting with sitting. Tap my category to discover the classes and the compensation factor.",
      cta: "Discover classes AS1–AS3",
      cats: {
        vi: {
          title: "Visually Impaired",
          tag: "My category",
          text: "Racing in pairs: a guide skis ahead and calls the line by voice. Two bodies, one single line.",
        },
        standing: {
          title: "Standing",
          tag: "Standing",
          text: "Athletes with limb impairments racing on their feet, with prosthetics or outriggers. Same course, same speed.",
        },
        sitting: {
          title: "Sitting",
          tag: "Sitting",
          text: "Racing seated on a mono-ski: a seat with a shock absorber mounted on a single ski.",
        },
      },
    },
    vi: {
      eyebrow: "How it works",
      titleA: "VISUALLY IMPAIRED ",
      titleAccent: "CATEGORY",
      intro: "In my category you ski in pairs: the guide ahead calls the line by voice, I follow at over a hundred kilometres an hour. Athletes are split into classes based on how much they see — and the stopwatch adapts to each one.",
      myClass: "My class",
      factorLabel: "Factor",
      disciplineLabel: "Discipline",
      classes: {
        as1: {
          name: "Totally blind",
          short: "totally blind",
          what: "They see nothing: on the course they follow only the guide's voice, coming from a loudspeaker.",
          simple: "Only voice, course memory and trust matter out there.",
        },
        as2: {
          name: "Severely visually impaired",
          short: "severe low vision",
          what: "Visually impaired athletes with very reduced sight.",
          simple: "Athlete and guide talk through a helmet microphone, turn after turn.",
        },
        as3: {
          name: "Visually impaired",
          short: "low vision",
          what: "Visually impaired athletes: visual acuity never exceeds 1/10 per eye. This is my class.",
          simple: "My guide and I talk through a helmet microphone: we read the line together.",
        },
      },
      raceTitleA: "THE COMPENSATION ",
      raceTitleAccent: "FACTOR",
      raceText: "On the course an AS3 skis faster than an AS1 and crosses the finish line first. But what counts is the real time multiplied by the class factor: the more severe the impairment, the lower the factor — the stopwatch runs slower. Watch how the final times line up.",
      raceStart: "Start the race",
      raceRunning: "Racing...",
      raceCorrecting: "Applying factor...",
      raceReplay: "Replay",
      raceArrived: "Finished!",
      raceTargetLabel: "Factored time",
      netTime: "Real time",
      corrTime: "Factored time",
      raceConclusion: "On the snow the AS3 won, the fastest outright. But after multiplying by the factors, the three times coincide: a tie. This is how classes with different impairments can race together.",
      raceDisclaimer: "Official FIS factors for the VI category in the selected discipline; race times are a didactic example.",
      calcTitle: "TIME CONVERTER",
      calcText: "From real time to factored time and back: enter several athletes' times after a race and compare them.",
      calcDirToFactored: "Real → Factored",
      calcDirToReal: "Factored → Real",
      calcInputReal: "Real time (on course)",
      calcInputFactored: "Factored time (official)",
      calcOutputFactored: "Factored time",
      calcOutputReal: "Real time",
      calcPlaceholder: "e.g. 62.34 or 1:02.34",
      calcInvalid: "Invalid format",
      calcAthlete: "Athlete {n}",
      calcRanking: "Compared standings",
      guidesTitle: "MY GUIDES",
      guidesText: "Behind every race of mine there is a guide skiing ahead, speaking into my earpiece at every turn. From the most recent to the first:",
      guideCurrent: "Current",
    },
    hero: {
      badge: "Paralympic Alpine Skiing — Visually Impaired",
      payoff: "Beyond the dark, pure speed. A mountain is not something you watch: you feel it, you live it, you win it.",
      ctaPercorso: "Discover my journey",
      ctaRisultati: "See the medal table",
      ctaCollab: "Let's collaborate",
      scrollAria: "Scroll down",
      imgAlt: "Giacomo Bertagnolli racing",
    },
    marquee: {
      identity: [
        "PARALYMPIC ALPINE SKIING",
        "GUIDE: ANDREA RAVELLI",
        "BEYOND THE DARK, PURE SPEED",
      ],
      results: [
        "124 WORLD CUP MEDALS",
        "2 OVERALL WORLD CUPS",
        "WORLD & PARALYMPIC CHAMPION",
      ],
      honors: [
        "FLAG BEARER AT BEIJING 2022",
        "COMMENDATORE OF THE ITALIAN REPUBLIC",
      ],
    },
    chiSono: {
      outline: "ABOUT ME",
      eyebrow: "About me",
      titleA: "YOU DON'T WATCH THE MOUNTAIN.",
      titleB1: "YOU ",
      titleAccent: "FEEL",
      titleB2: " IT.",
      badge: "VISUALLY IMPAIRED · CLASS AS3",
      photoFlagCaption: "Flag bearer — Beijing 2022",
      photoMattarellaCaption: "The Tricolore from President Mattarella — Quirinale 2021",
      photoInspectCaption: "Pre-race inspection — Downhill, Milano Cortina 2026",
      photoSlalomCaption: "Slalom race — Milano Cortina 2026",
      p1: "I was born in Cavalese, in Val di Fiemme, on 18 January 1999. I have been visually impaired since birth, due to bilateral optic nerve atrophy. I learned early that, in skiing, sight is only one of the ways to read a course: you also need instinct, memory, sensitivity and trust.",
      body: [
        "My racing career began in the 2012/13 season. In 2014/15 I joined the Italian national team and in 2015 I made my World Cup debut, taking my first giant slalom podium in St. Moritz.",
        "In races I ski following the voice and movements of my guide. Today it is Andrea Ravelli; before him, by my side, there were Achille Crispino and Fabrizio Casal. Two athletes, one single line: an understanding made of coordination, listening and mutual trust, even when the speed goes past a hundred kilometres an hour.",
        "Since 2017 I have worn the colours of the Fiamme Gialle and since 2022 I have been a full-fledged member of the Guardia di Finanza.",
        "In 2022, in Madonna di Campiglio, I became the first Paralympic athlete to forerun an able-bodied alpine skiing World Cup race. In the same year, the President of the Republic Sergio Mattarella named me Commendatore of the Order of Merit of the Italian Republic.",
        "I have also had the honour of being Italy's flag bearer in two editions of the Paralympic Games, a role that allowed me to represent my country and the values of sport in a context that goes beyond competition.",
        "Sport has brought me to important achievements, but for me every result is a starting point, not a finish line.",
        "Today my goal is to keep improving, as an athlete, as a skier and as a person. To look for new stimuli, keep raising the bar and challenge myself, on and off the course.",
        "At the same time, I want to share my passion, my experiences and what sport has taught me with those who follow me, with those who love the mountains and with the organisations that believe in the value of sport and people. Because experiences gain even more value when they can become a stimulus for others too.",
        "My story is about skiing, competition and goals to reach. But also about trust, determination and the will to always push further.",
      ],
      closing: "The next goal? Keep winning. On the course, and beyond.",
      stats: ["World Cup medals", "World Championship medals", "Paralympic medals", "Discipline Cups"],
      portraitAlt: "Portrait of Giacomo Bertagnolli",
      actionAlt: "Giacomo in action on the snow",
      fedFisi: "Italian Winter Sports Federation",
      fedFg: "Fiamme Gialle Sports Group",
      fedAgitos: "Paralympic symbol (Agitos)",
    },
    percorso: {
      eyebrow: "My journey",
      titleA: "EVERY TURN HAS ",
      titleAccent: "ITS OWN STORY",
      subtitle: "Tap a year to open that season's results in the full archive.",
      ctaYear: "Results",
      items: [
        { title: "Milano Cortina 2026", desc: "The home Games: 5 medals in 5 races and an Italian record of 13 Paralympic podiums.", tag: "Paralympics" },
        { title: "Maribor and the perfect season", desc: "Two world titles and a World Cup clean sweep: the overall plus every discipline cup.", tag: "Worlds & Cup" },
        { title: "Espot World Championships", desc: "Two more world titles — giant slalom and slalom — plus silver and bronze.", tag: "Worlds" },
        { title: "Beijing 2022", desc: "Flag bearer at the opening, then two golds and two silvers. At the end of the year, Commendatore of the Republic.", tag: "Paralympics" },
        { title: "The world poker", desc: "Between Sella Nevea and Kranjska Gora: four world titles out of five.", tag: "Worlds" },
        { title: "PyeongChang 2018", desc: "A dream Paralympic debut at 19: two golds, one silver, one bronze.", tag: "Paralympics" },
        { title: "First world title", desc: "At the Tarvisio Worlds, on home snow, the first world gold of my career. That same year I became the first Paralympic athlete to officially join a sports group: the Fiamme Gialle.", tag: "Worlds" },
        { title: "The first overall World Cup", desc: "In Aspen, Colorado, with my guide Fabrizio Casal I win the first overall World Cup of my career.", tag: "World Cup" },
        { title: "National team and first World Cup podium", desc: "World Cup debut with the national team: straight onto the podium in St. Moritz.", tag: "World Cup" },
        { title: "Where it all began", desc: "The first race and the first Italian podium, at Campo Felice. From there, only downhill.", tag: "Origins" },
      ],
    },
    a11y: {
      open: "Open accessibility options",
      close: "Close accessibility panel",
      title: "ACCESSIBILITY",
      desc: "Tools designed for screen-reader users and anyone who prefers an easier read.",
      mode: "Accessible mode",
      modeHint: "Larger text, higher contrast, no animations",
      listen: "Read the page aloud",
      listenSection: "Listen to this section",
      stop: "Stop reading",
      skip: "Skip to content",
    },
    podio: {
      eyebrow: "Results",
      titleA: "THE ",
      titleAccent: "MEDAL TABLE",
      subtitle: "Every medal is a story of snow, trust and speed. The counts update automatically with every new result.",
      tabs: { paralimpiadi: "Paralympics", mondiali: "World Championships", coppa_mondo: "World Cup", coppe: "Crystal globes", collare: "Gold Collar" },
      place1: "1ST PLACE",
      place2: "2ND PLACE",
      place3: "3RD PLACE",
      ctaAll: "See all results",
      collareTitle: "COLLARE D'ORO FOR SPORTING MERIT",
      collareSub: "Italy's highest sporting honour — 6 times",
      diplomaNote: "+ Diploma d'Onore 2026",
      cupOverall: "OVERALL WORLD CUPS",
      cupOverallSub: "Seasons 2015–16 · 2019–20",
      cupDiscipline: "DISCIPLINE WORLD CUPS",
      cupDisciplineSub: "Downhill · Super-G · Giant slalom · Slalom",
      videoHint: "— and relive the races: watch the videos",
    },
    news: {
      eyebrow: "Stay tuned",
      titleA: "CALENDAR ",
      titleAccent: "& NEWS",
      subtitle: "The upcoming races on the calendar and the latest stories from on and off the slopes.",
      agendaHeading: "Upcoming races",
      pastHeading: "This season's races",
      newsHeading: "Latest news",
      emptyAgenda: "The new season calendar will be announced soon. Stay tuned!",
      emptyNews: "No news for now: come back soon.",
      showAll: "See all races (+{n})",
      showLess: "Show less",
      readMore: "Read more",
      zoomImage: "Open image fullscreen",
      close: "Close",
      circuitWc: "World Cup",
      circuitWch: "World Championships",
      circuitPar: "Paralympics",
      legendTech: "technical",
      legendSpeed: "speed",
      noFilterResults: "No races with the selected filters: re-enable a category or a discipline type.",
      noEvents: "No events scheduled for now.",
      openMaps: "Open in Google Maps",
      eventsHeading: "Upcoming events",
      inDays: "IN {n} DAYS",
      today: "TODAY",
      tomorrow: "TOMORROW",
      read: "Read",
      disciplines: "Disciplines",
      archiveCta: "Press archive",
    },
    video: {
      eyebrow: "The videos",
      title: "RACE VIDEOS",
      subtitle: "Full runs and award ceremonies: the players start right at the race moment.",
      run1: "1st run",
      run2: "2nd run",
      premiazione: "Award ceremony",
      partGara: "Race",
      partSG: "Super-G · 1st run",
      partSL: "Slalom · 2nd run",
      partPE: "Parallel Event",
      scopeVi: "full VI category",
      scopeFull: "full race",
      commentIt: "Italian commentary",
      commentEn: "English commentary",
      openExt: "Watch on",
      extraTitle: "INTERVIEWS AND TV FEATURES",
      extraSub: "TV features, interviews and awards: they open on the source website.",
      seasonLabel: "Season",
      archiveTitle: "From the TV archives",
      open: "Watch the videos",
      raiFolder: "RAI & EXTERNAL VIDEOS",
      raiNote: "Non-embeddable videos (Rai, Eurosport and others) are kept here: they open on the broadcaster's site.",
      disc: { gs: "Giant Slalom", sl: "Slalom", dh1: "Downhill 1", dh2: "Downhill 2", dh3: "Downhill 3", sg1: "Super-G 1", sg2: "Super-G 2", pe: "Parallel Event", evento: "Event" },
    },
    press: {
      eyebrow: "In the media",
      titleA: "PRESS ",
      titleAccent: "ARCHIVE",
      subtitle: "Articles from Italian and international media, collected by event and always up to date.",
      statArticles: "articles",
      statSources: "outlets",
      all: "All",
      readArticle: "Read the article",
      backArchive: "Press archive",
      readOriginal: "Read the original article",
      externalNote: "This article is published on the outlet's website: the button opens the source in a new tab.",
      notFound: "Article not found.",
      empty: "No articles in the archive yet.",
      groups: {
        "milano-cortina-2026": "Milano Cortina 2026 Paralympics",
        "sanremo-2026": "Sanremo Festival 2026",
        "onorificenze": "Honours & Institutions",
        "mondiali-2025": "Maribor 2025 World Championships",
        "coppa-del-mondo": "World Cup",
        "beijing-2022": "Beijing 2022 Paralympics",
        "pyeongchang-2018": "PyeongChang 2018 Paralympics",
        "altro": "More articles",
      },
    },
    gallery: {
      eyebrow: "Moments",
      titleA: "THE ",
      titleAccent: "ALBUMS",
      subtitle: "Open an album to browse the best shots.",
      photosCount: "{n} photos",
      loading: "Loading albums...",
      emptyPhotos: "Photos for this album are coming soon.",
      close: "Close",
      lightboxAlt: "Album photo",
      prev: "Previous photo",
      next: "Next photo",
    },
    sponsor: {
      eyebrow: "Sponsors & partners",
      titleA: "TOGETHER WE GO ",
      titleAccent: "STRONGER",
      subtitle: "Behind every descent there is a team: those who equip me and those who believe in Paralympic sport. Tap a logo to discover the partnership.",
      mainTitle: "SPONSORS",
      techTitle: "TECHNICAL SPONSORS",
      tagMain: "Sponsor",
      tagTech: "Technical Sponsor",
      loading: "Loading sponsors...",
    },
    collab: {
      eyebrow: "Collaborations",
      titleA: "COLLABORATIONS ",
      titleAccent: "& EVENTS",
      subtitle: "Meetings, events and projects born with companies that wanted to tell their values through my story. Tap a logo to discover the project.",
      tagline: "Special project",
      taglineYear: "Special project · {year}",
      ctaTitleA: "A PROJECT TO BUILD ",
      ctaTitleAccent: "TOGETHER",
      ctaText: "If you think my experience — on and off the slopes — could be valuable for your company, we can build something together. An event, a meeting, a story: let's start with a coffee and an idea.",
      ctaBtn: "Let's talk",
      outline: "TOGETHER",
    },
    oltre: {
      eyebrow: "Beyond sport",
      titleA: "MY STORY CAN GO",
      titleAccent: "BEYOND THE SLOPES",
      lead: "My experience can become the starting point for new projects.",
      body: "On the slopes I learned things you won't find in books: what it means to trust someone at a hundred kilometres an hour, to turn a limit into a method, to get back up after every fall. When a company calls me — for a meeting, an event, a project — this is what I bring: not a motivational speech, but my story. A real one.",
      cta: "Discover the projects",
      ctaContact: "Write to me",
      altA: "Project with a company",
      altB: "Behind the scenes of a project",
    },
    contatti: {
      eyebrow: "Contact",
      titleA: "LET'S HIT THE SLOPES",
      titleAccent: "TOGETHER",
      subtitle: "Press, sponsors, events or simply to chat about Paralympic skiing: write to me. Every collaboration is a new start.",
      follow: "Follow me",
      namePh: "Full name",
      emailPh: "Email",
      orgPh: "Organization / Company (optional)",
      subjectPh: "Subject",
      messagePh: "Your message",
      submit: "Send message",
      sending: "Sending...",
      toastSuccess: "Message sent! I'll get back to you as soon as possible.",
    },
    modal: {
      project: "The project",
      experience: "My experience",
      cta: "Let's talk",
      visit: "Visit the company",
      close: "Close",
    },
    footer: {
      admin: "Restricted Area",
      rights: "All rights reserved",
    },
    risultati: {
      back: "Back to home",
      eyebrow: "Complete archive",
      titleA: "ALL ",
      titleAccent: "RESULTS",
      subtitle: "Open an edition or a season to explore the venues and individual races.",
      statRaces: "races",
      statPodiums: "podiums",
      statWins: "wins",
      filters: { tutti: "All", paralimpiadi: "Paralympics", mondiali: "World Championships", coppa_mondo: "World Cup", coppe: "Crystal globes", altro: "Other", onorificenze: "Honours" },
      searchPh: "Search race, venue...",
      mapTitle: "RACES AROUND THE WORLD",
      mapHint: "Each pin is a country: tap it to open its races · drag and zoom to explore",
      mapOpen: "View on map",
      mapZoomIn: "Zoom in",
      mapZoomOut: "Zoom out",
      mapLegendGold: "Win venues",
      mapLegendOther: "Other races",
      mapStats: "{races} races · {podiums} podiums · {venues} venues",
      loading: "Loading results...",
      empty: "No results found.",
      racesCount: "{n} races",
      seasonEyebrow: "Season",
      eventEyebrow: { paralimpiadi: "Paralympics", mondiali: "World Championships" },
      altroHeading: "FIS Races · Italian Championships · European Cup",
      golds: "Golds",
      silvers: "Silvers",
      bronzes: "Bronzes",
      honoursTitle: "HONOURS",
      coppeTitle: "CRYSTAL GLOBES",
      coppeSub: "The World Cup titles: the overall crown and the discipline globes won, season by season.",
      coppeOverall: "Overall World Cup",
      coppeDownhill: "Downhill",
      coppeSuperG: "Super-G",
      coppeGiant: "Giant slalom",
      coppeSlalom: "Slalom",
      coppeSummaryOverall: "overall",
      coppeSummaryDisc: "discipline",
      honoursSub: "These are not medals, but the highest honours of Italian sport and State: that's why they have their own space here.",
      collareChip: "Gold Collar",
      collareTagline: "Italy's highest sporting honour, awarded by CONI — won 6 times",
      diplomaNew: "New",
      flagTagline: "Italian flag bearer at two editions of the Paralympic Games",
      flagPhotoAlt: "Giacomo Bertagnolli with the Italian flag at Beijing 2022",
      flagClosing: "Closing ceremony",
      flagOpening: "Opening ceremony",
      diplomaTagline: "CONI's recognition for those who have already won the Gold Collar",
      diplomaText: "On 12 October 2026, in Rome, CONI awarded me the Diploma d'Onore for Sporting Merit for the five medals won at the Milano Cortina 2026 Games: after six Gold Collars, those who keep winning receive the Diploma.",
      commendatoreTagline: "Order of Merit of the Italian Republic",
      commendatoreText: "On 2 June 2022 President Mattarella conferred on me the honour of Commendatore of the Order of Merit of the Italian Republic: the award with which the State recognises those who bring prestige to the country, in sport and beyond.",
      photoComing: "Photo coming soon",
    },
    lang: { label: "Language", it: "IT", en: "EN" },
  },
};

export const tpl = (s, vars) => (typeof s === "string" ? s.replace(/\{(\w+)\}/g, (_, k) => (vars?.[k] ?? `{${k}}`)) : s);
